/**
 * 编辑员工 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XTitle } from '@/components/xqxc_ui';
import { Modal, message, Form, Checkbox, Select } from 'antd';
import styles from './EditStaff.module.scss';
import model from '@/reducers/permissions/assignauthority/model';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    labelAlign: 'left',
};

class EditStaff extends React.Component {

    formRef = React.createRef();
    state = {
        title: this.props.title,
        confirmLoading: false,
        roleSelect: []
    }

    componentDidMount() {
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.listRoleByEmpl', { emplId: this.props.data.id }, 'POST').then((response) => {
            this.setState({ roleSelect: response.result }, () => {
                const { roleSelect } = this.state;
                let checkList = [];
                for (let i = 0; i < roleSelect.length; i++) {
                    if (roleSelect[i].isChecked == 1) {
                        checkList.push(roleSelect[i].id);
                    }
                }
                this.formRef.current.setFieldsValue({ roleIds: checkList });
            });
        }).catch((e) => {
            message.error(e.message);
        });
    }

    // 点击确认
    _handleOk = () => {
        const { data } = this.props;
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { roleIds } = fieldsValue;
            http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleEmplMisService.saveRoleEmpl', { emplIds: data.id, roleIds: roleIds.toString() }, 'POST').then(() => {
                message.success('编辑成功！');
                this.props.closeMode(true);
            }).catch((e) => {
                message.error(e.message);
            });

        });
    }

    // 点击取消
    _handleCancel = () => {
        this.props.closeMode();
    }

    render() {
        const { confirmLoading, title, roleSelect } = this.state;
        const { data } = this.props;
        const adminRoleOption = roleSelect.map((item) => {
            return {
                key: item.id,
                value: item.id,
                label: item.roleName,
            };
        });
        return (
            <Modal
                width={900}
                centered
                title={title}
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        {...formItemLayout}
                        layout="vertical"
                        ref={this.formRef}
                        scrollToFirstError
                    >
                        <XTitle label={`${'员工“' + data.emplName + '”角色管理'}`} style={{ marginBottom: '20px' }} />
                        <Form.Item
                            name="roleIds"
                            rules={[
                                { required: true, message: '请选择角色' }
                            ]}>
                            <Checkbox.Group
                                options={adminRoleOption}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

EditStaff.propTypes = {
    data: PropTypes.object, // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string, // 弹框标题
};

export default connect(null, { ...model.actions })(EditStaff);